<p-card class="shadow-lg mb-5" [style]="{ 'border-radius': '0.5rem' }">
  <!-- Responsive flex container -->
  <div class="flex flex-wrap gap-4">
    <!-- Issuer -->
    <div class="min-w-[250px]">
      <label class="block text-sm font-medium mb-1">Issuer Name</label>
      <input
        pInputText
        type="text"
        pSize="small"
        placeholder="Search issuer..."
        class="w-full"
        [(ngModel)]="filters.issuerName"
        #issuerNameInput="ngModel"
        (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event)"
        (blur)="onIssuerNameBlur()"
        (keydown.enter)="onSubmitFilters()"
      />
    </div>

    <!-- Announcement Date (From) -->
    <div class="min-w-[250px]">
      <label class="block text-sm font-medium mb-1"
        >Announcement Date (From)</label
      >
      <p-datepicker
        appendTo="body"
        dateFormat="mm-dd-yy"
        placeholder="mm-dd-yyyy"
        class="w-full p-0 h-4"
        [size]="'small'"
        [style]="{ width: '100%' }"
        (onSelect)="onSubmitFilters()"
        [(ngModel)]="filters.announcementFrom"
        [showClear]="true"
        (onClear)="onSubmitFilters()"
        [showIcon]="true"
      ></p-datepicker>
    </div>

    <!-- Announcement Date (To) -->
    <div class="min-w-[250px]">
      <label class="block text-sm font-medium mb-1"
        >Announcement Date (To)</label
      >
      <p-datepicker
        appendTo="body"
        dateFormat="mm-dd-yy"
        placeholder="mm-dd-yyyy"
        class="w-full h-4"
        [size]="'small'"
        [style]="{ width: '100%' }"
        (onSelect)="onSubmitFilters()"
        [(ngModel)]="filters.announcementTo"
        [showClear]="true"
        (onClear)="onSubmitFilters()"
        [showIcon]="true"
      ></p-datepicker>
    </div>

    <!-- Clear Filters Button -->
    <div class="flex items-end min-w-[150px]">
      <button
        pButton
        label="Clear All"
        icon="pi pi-filter-slash"
        class="p-button-secondary w-full"
        [disabled]="!isFiltersActive()"
        [ngClass]="{
          'opacity-50 cursor-not-allowed': !isFiltersActive(),
          'bg-clear-button': isFiltersActive()
        }"
        (click)="clearFilters()"
      ></button>
    </div>
  </div>
</p-card>

<!--  PrimeNG Table -->

<div
  #scrollContainer
  class="mt-4 overflow-auto"
  style="max-height: calc(100vh - 250px)"
>
  <p-table
    [value]="plansData"
    styleClass="p-datatable-gridlines"
    [(selection)]="selectedInsiders"
    (selectionChange)="onSelectionChange($event)"
    [paginator]="plansData.length > 0"
    [first]="first"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [totalRecords]="paginator.totalCount"
    [rows]="paginator.pageSize"
    [loading]="isLoading"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="pageChange($event)"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="fixed-table"
     dataKey="issuerId"
  >
    <!-- Main header shown only once -->
    <ng-template pTemplate="header">
      <tr>
        <!-- <th style="width: 4rem">
          <p-tableHeaderCheckbox />
        </th> -->
        <th>Filing Date</th>
        <th>FID</th>
        <th>Trading PlanId</th>
        <th>Insider Name</th>
        <!-- <th>Relation</th> -->
        <th>D/I</th>
        <th>Plan Action</th>
        <th>Adoption Date</th>
        <th>Effective Date</th>
        <th>Amendment Date</th>
        <th>Termination Date</th>
        <th>Expiration Date</th>
        <th>Security</th>
        <th>Transaction</th>
        <th>Shares</th>
        <th>Shares Description</th>
        <th>Notional Value</th>
        <th>Link</th>
      </tr>
    </ng-template>

    <!-- Issuer group header -->
    <ng-template pTemplate="body" let-group>
      <tr
        [ngClass]="{
          'bg-light-row font-semibold': !group.issuerDuplicate,
          'highlight-plan-row font-semibold': group.issuerDuplicate
        }"
      >
        <!-- <td>
          <p-tableCheckbox [value]="group" />
        </td> -->
        <td colspan="16" class="text-blue-600 hover:underline">
          <span class="cursor-pointer" (click)="navigateToIssuer(group)">
            {{ group.issuer }}
          </span>
        </td>
      </tr>

      <ng-container *ngFor="let plan of group.plans">
        <tr [ngClass]="{ 'highlight-plan-row': plan.tradingPlanDuplicate }">
          <!-- <td></td> -->
          <td class="cell-ellipsis">
            {{ plan.filingDate }}
          </td>
          <td class="cell-ellipsis">
            {{ plan.filingId }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedOther"
              class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >O</sup
            >
          </td>
          <td>
            {{ plan.tradingPlanId }}
          </td>
          <td>
            {{ plan.insiderName }}
          </td>
          <!-- <td>{{ plan.relation }}</td> -->
          <td>
            <span
              [pTooltip]="plan.relationType === 'I' ? plan.relationInsiderName : null"
              tooltipPosition="top"
              tooltipStyleClass="tooltip-relation-type"
              style="cursor: pointer;"
            >
              {{ plan.relationType }}
            </span>
          </td>
<!--          <td>-->
<!--            <span-->
<!--              [pTooltip]="plan.relationInsiderName || null"-->
<!--              tooltipPosition="top"-->
<!--              tooltipStyleClass="tooltip-relation-type"-->
<!--              style="cursor: pointer;"-->
<!--            >-->
<!--              {{ plan.relationType }}-->
<!--            </span>-->
<!--          </td>-->
          <td>
            <div class="flex items-center gap-1">
              <!-- Plan Action Label -->
              <span
                class="px-2 py-1 rounded text-xs font-medium"
                [ngClass]="{
                  'bg-blue-100 text-blue-700':
                    plan.planAction?.toLowerCase() === 'adoption',
                  'bg-purple-100 text-purple-700':
                    plan.planAction?.toLowerCase() === 'amendment',
                  'bg-yellow-100 text-yellow-700':
                    plan.planAction?.toLowerCase() === 'termination'
                }"
              >
                {{ plan.planAction | titlecase }}
              </span>

              <!-- SUP (Modification Badge) -->
              <sup
                *ngIf="plan.modifiedFields?.modifiedPlanAction"
                class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >
                M
              </sup>
            </div>
          </td>

          <td class="cell-ellipsis">
            {{ plan.adoptionDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedAdoptionDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
            <sup
              *ngIf="plan.isEstimateAdoptionDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >E</sup
            >
          </td>
          <td class="cell-ellipsis">
            {{ plan.effectiveDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedEffectiveDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
          </td>
          <td class="cell-ellipsis">
            {{ plan.amendmentDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedAmendmentDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
              <sup
              *ngIf="plan.isEstimateAmendedDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >E</sup
            >
          </td>
          <td class="cell-ellipsis">
            {{ plan.terminationDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedTerminationDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
            <sup
              *ngIf="plan.isEstimateTerminationDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >E</sup
            >
          </td>
          <td class="cell-ellipsis">
            {{ plan.expirationDate }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedExpirationDate"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
          </td>
          <td>{{ plan.security }}</td>
          <td>
            <div class="space-x-1">
              <span
                [ngClass]="{
                  'transaction-buy':
                    plan.Transaction?.toLowerCase().startsWith('buy'),
                  'transaction-sell':
                    plan.Transaction?.toLowerCase().startsWith('sell')
                }"
              >
                {{ plan.Transaction?.split(" ")[0] || plan.Transaction || "-" }}
                <span
                  class="transaction-code"
                  *ngIf="plan.Transaction?.split(' ')?.[1]"
                  >{{ plan.Transaction?.split(" ")[1] }}</span
                >
              </span>
              <sup
                *ngIf="
                  getStringForTransactionTags([
                    plan.asReportedSecurityBreakdownTags
                  ]) as tagText
                "
                class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >
                {{ tagText }}
              </sup>
              <sup
                *ngIf="plan.modifiedFields?.modifiedTransactionType"
                class="text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >
                M
              </sup>
            </div>
          </td>
          <td>
            {{ plan.shares | number : "1.0-0" }}
            <sup
              *ngIf="plan.modifiedFields?.modifiedNumberOfShares"
              class="ml-1 text-xs px-1 rounded bg-yellow-300 text-gray-900 font-semibold"
              >M</sup
            >
          </td>
          <td
            class="cell-ellipsis"
            [pTooltip]="plan.sharesDescription"
            tooltipPosition="top"
          >
            {{ plan.sharesDescription }}
          </td>

          <td>{{ plan.nationalValue }}</td>
          <td>
            <a
              [href]="plan.filingLink"
              target="_blank"
              rel="noopener noreferrer"
              class="text-blue-500 cursor-pointer flex items-center gap-1"
            >
              <i class="pi pi-link"></i>
            </a>
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="16" class="w-full text-center text-gray-500 py-4">
          No records found
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
